import { IResponseBase, Repository } from './Repository'
import api from 'services/api'
import { AxiosRequestConfig } from 'axios'

class LevelsRepository extends Repository {
  async selectLevel (level: string, config?: AxiosRequestConfig): Promise<IResponseBase> {
    return Repository.handle(() =>
      this.api.get(`/signin/select/${level}`, config)
    )
  }
}

export default new LevelsRepository({ api, path: '/levels' })
